import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { SubscriberService } from './../../../_services/admin/subscriber.service';

@Component({
  selector: 'app-subscribers',
  templateUrl: './subscribers.component.html',
  styleUrls: ['./subscribers.component.scss']
})
export class SubscribersComponent implements OnInit {

  subscribeList: any[] = [];
  tempSubscribeList: any[] = [];

  constructor(private subscriberService: SubscriberService, private myTitle: Title) {
  }

  ngOnInit() {
    this.myTitle.setTitle('Subscribers | ' + environment.commonTitle);
    this.getSubscriber();
  }

  getSubscriber() {
    this.subscriberService.getAllSubscriber().subscribe(result => {
      if (result.data) {
        this.subscribeList = result.data;
        this.tempSubscribeList = [...this.subscribeList];
      }
    });
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    // filter our data
    const temp = this.tempSubscribeList.filter(function (d) {
      return d.email.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.subscribeList = temp;
  }

}
